import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import SectionTitle from "@/components/base/SectionTitle";
import { useHashScroll } from "@/hooks/useHashScroll";

export default function Service() {
  useHashScroll();

  const envTests = [
    {
      title: "ガス腐食試験",
      icon: "ri-flask-line",
      link: "/service/test-guide#gas-corrosion",
      bgImage: "https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/32c71fb0-4a36-40dd-9450-7467ac840857_compressed_IMG_5500-2.webp",
    },
    {
      title: "接触抵抗評価試験",
      icon: "ri-dashboard-line",
      link: "/service/test-guide#contact-resistance",
      bgImage: "https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/c5b3bb46-d31b-44b0-965a-8fc8b03761e8_compressed_Untitled-design-3-1.webp",
    },
    {
      title: "その他受託試験",
      icon: "ri-customer-service-line",
      link: "/service/test-guide#other-tests",
      bgImage: "https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/a0036a0f-cecf-4141-bc31-668c54167c68_compressed_IMG_5493-Copy.webp",
    },
  ];

  return (
    <PageLayout>
      <div className="relative py-14 md:py-20 bg-primary-700 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/34c80b3c-5e78-4167-8574-c0055f9b0bf8_compressed_IMG_5505.webp"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-4xl mx-auto">
            <nav className="mb-4">
              <ol className="flex items-center gap-2 text-sm text-background-300">
                <li>
                  <Link to="/" className="hover:text-background-100 transition-colors">
                    ホーム
                  </Link>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line text-xs" />
                </li>
                <li className="text-background-100">サービス</li>
              </ol>
            </nav>
            <h1 className="text-3xl md:text-4xl font-black text-background-50">サービス</h1>
            <p className="text-accent-300 text-sm mt-2">our services</p>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-5xl mx-auto">
          <SectionTitle
            title="各種環境試験"
            subtitle="より良い製品を作るには、事前に部品の評価を行うことをおすすめします"
            centered
          />

          <p className="text-center text-sm text-foreground-600 mt-4 max-w-2xl mx-auto">
            例えば・・・・新しい部品を使用する時<br />
            例えば・・・・部品メーカーを変更する時
          </p>

          {/* Image Cards - linking to 受託試験のご案内 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-10">
            {envTests.map((test, i) => (
              <Link
                key={i}
                to={test.link}
                className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300"
              >
                <div className="relative h-44 md:h-52 overflow-hidden">
                  <img
                    src={test.bgImage}
                    alt={test.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-all duration-300" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm border border-white/30 group-hover:bg-white/30 transition-all duration-300">
                      <i className={`${test.icon} text-2xl text-white`} />
                    </div>
                  </div>
                </div>
                <div className="p-4 md:p-5 text-center">
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {test.title}
                  </h3>
                  <div className="mt-2 flex items-center justify-center gap-1 text-sm text-primary-500 font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span>詳しく見る</span>
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* 受託試験のご案内 Card */}
          <div className="mt-10">
            <Link
              to="/service/test-guide"
              className="block bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/30 transition-all duration-300 group overflow-hidden"
            >
              <div className="flex flex-col md:flex-row items-center gap-5 p-6 md:p-8">
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className="ri-article-line text-2xl" />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-lg font-bold text-foreground-900 mb-1">受託試験のご案内</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    試験の流れや具体的な試験内容、料金の目安など、受託試験に関する詳しい情報をご案内しております。特殊な試験条件についても、お気軽にご相談ください。
                  </p>
                </div>
                <div className="shrink-0 flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-semibold group-hover:bg-primary-500 group-hover:text-background-50 transition-colors whitespace-nowrap border border-background-200/70 group-hover:border-primary-500">
                  <span>詳しく見る</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          </div>

          {/* 試験の代表例 Card */}
          <div className="mt-6">
            <a
              href="https://www.factk.jp/factk/pdf/ex01_02.pdf"
              target="_blank"
              rel="noreferrer nofollow"
              className="block bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/20 transition-all duration-300 group overflow-hidden"
            >
              <div className="flex flex-col md:flex-row items-center gap-5 p-6 md:p-8">
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 shrink-0 group-hover:bg-primary-200 transition-colors">
                  <i className="ri-file-pdf-line text-2xl" />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-lg font-bold text-foreground-900 mb-1">試験の代表例</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    ガス腐食試験の代表的な実例をPDF資料としてご覧いただけます。試験の具体的な内容や結果のイメージを掴むのにご活用ください。
                  </p>
                </div>
                <div className="shrink-0 flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-semibold group-hover:bg-primary-500 group-hover:text-background-50 transition-colors whitespace-nowrap border border-background-200/70 group-hover:border-primary-500">
                  <span>PDFを見る</span>
                  <i className="ri-arrow-right-up-line" />
                </div>
              </div>
            </a>
          </div>

          {/* Gas & Equipment Info */}
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-accent-50 rounded-xl p-6 border border-accent-100">
              <h4 className="text-base font-bold text-accent-900 mb-2">対応ガス・規格</h4>
              <p className="text-sm text-accent-800 leading-relaxed">
                5種の腐食性ガス（H2S、SO2、NO2、Cl2、O3）の単独および混合ガス試験に対応。
                ISO、IEC、JIS、EIA、Battelle、ASTMなど各種規格に準拠した試験が可能です。
              </p>
            </div>
            <div className="bg-secondary-50 rounded-xl p-6 border border-secondary-100">
              <h4 className="text-base font-bold text-secondary-900 mb-2">試験機器ラインナップ</h4>
              <div className="text-sm text-secondary-800 leading-relaxed space-y-1.5">
                <p>
                  ガス腐食試験機：
                  <Link to="/products#kg200" className="font-semibold text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors">
                    KG200
                  </Link>
                  {" / "}
                  <Link to="/products#kg600" className="font-semibold text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors">
                    KG600
                  </Link>
                </p>
                <p>
                  接触抵抗評価装置：
                  <Link to="/products#ms7500" className="font-semibold text-primary-600 hover:text-primary-700 underline underline-offset-2 transition-colors">
                    MS7500
                  </Link>
                </p>
                <p>各機器のスペック・試験槽内サイズについてもお問い合わせください。</p>
              </div>
            </div>
          </div>

          {/* Free Trial Banner */}
          <div className="mt-10">
            <Link
              to="/service/free-trial"
              className="block relative rounded-xl overflow-hidden group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500" />
              <div className="absolute inset-0 opacity-15">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20industrial%20laboratory%20interior%20with%20scientific%20testing%20equipment%2C%20clean%20white%20and%20bright%20atmosphere%2C%20professional%20yet%20welcoming%20environment%2C%20soft%20natural%20lighting%2C%20minimal%20composition%2C%20warm%20academic%20aesthetic&width=1200&height=300&seq=service-freetrial-banner&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative z-10 flex flex-col md:flex-row items-center gap-5 p-6 md:p-8">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm border border-white/30 group-hover:bg-white/30 transition-all">
                    <i className="ri-gift-line text-2xl text-white" />
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-flex items-center gap-1.5 mb-2">
                    <span className="px-2.5 py-0.5 rounded-full bg-white/20 border border-white/30 text-white text-xs font-bold">
                      期間限定
                    </span>
                    <span className="text-white/80 text-xs">完全無料キャンペーン</span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-black text-white mb-1">
                    ガス腐食試験 無料体験サービス
                  </h3>
                  <p className="text-sm text-white/70 leading-relaxed max-w-xl">
                    H₂S 3ppm または SO₂ 5ppm、24時間の短期集中試験を完全無料で体験いただけます。
                    試験実施からレポート作成、技術アドバイスまですべて無料。まずはお気軽にお試しください。
                  </p>
                </div>
                <div className="shrink-0 flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-600 font-bold text-sm group-hover:bg-background-50 transition-colors whitespace-nowrap">
                  <span>無料体験を申し込む</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}